import React from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { Link } from '@shared/components/link';
import { MBSeparator } from '@shared/components/list';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBText } from '@shared/components/text';
import { Colors } from '@shared/styles';
import { MBLinkPreviewProps } from './props';
import { Styles } from './styles';

/*
    Component to show a link preview. If no preview is set, a loading indicator
    is shown. If an image is provided in the link details, it is rendered.
    The reason we have the link prop nullable (as opposed to checking that in
    the container) is because our loading indicator requires styling. It would
    not be nice to have to do that in a container.
*/
export function MBLinkPreviewComponent({ link, style }: MBLinkPreviewProps) {
  if (!link) {
    return <MBLoadingIndicator style={[Styles.container, style]} />;
  }

  // Note: we wrap everything in a view with white background to make sure that
  // onPress doesn't show the background below (eg everything becoming blue in
  // a blue message bubble).
  return (
    <MBView style={[Styles.container, style]}>
      <Link href={link.url} underline={false}>
        <View fill row>
          {!!link.imageUrl && <MBImage style={Styles.image} source={{ uri: link.imageUrl }} />}
          {!!link.imageUrl && <MBSeparator vertical />}

          <View fill padding={1}>
            <MBText bold numberOfLines={1}>
              {link.title}
            </MBText>
            <MBView fill style={Styles.overflowHidden}>
              <MBText color={Colors.gray.normal} numberOfLines={2}>
                {link.description}
              </MBText>
            </MBView>
          </View>
        </View>
      </Link>
    </MBView>
  );
}
